module.exports = __webpack_public_path__ + "img/2025-10-15d_2.28548f95.jpg";